import { ControllerStore } from '@ayocore/platform/client/controllers/ControllerStore';
import logger from '@ayocore/platform/common/helpers/logger';
import type { SalesPlanClient, SalesPlanStats } from '../shared/reportTypes';

/** План/факт филиала и сотрудника для одного экземпляра виджета. */
export class SalesPlanWidgetController extends ControllerStore<{ stats: SalesPlanStats | null }> {
  private loadVersion = 0;

  constructor(private readonly repository: Pick<SalesPlanClient, 'getWelcomeStats'>) {
    super({ stats: null });
  }

  async load(): Promise<void> {
    const version = ++this.loadVersion;
    try {
      const stats = await this.repository.getWelcomeStats();
      if (version === this.loadVersion) {
        this.setState({ stats: stats.current.quarterLabel ? stats : null });
      }
    } catch (error) {
      if (version === this.loadVersion) logger.error('Failed to load sales plan stats:', error);
    }
  }

  cancelLoad(): void {
    this.loadVersion += 1;
  }
}
